import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppInitService } from '../../services/app-init.service';
//import { SERVER_URL } from 'src/app/digigov/constants/common.config';
//import { DOC_URL } from 'src/app/digigov/constants/common.config';

@Component({
  selector: 'app-dg-file-upload-test',
  templateUrl: './dg-file-upload-test.component.html',
  styleUrls: ['./dg-file-upload-test.component.scss'],
})
export class DgFileUploadTestComponent implements OnInit {
  //	doc_url = DOC_URL+"/components/DgFileUploadComponent.html";
  doc_url;
  //specific To single Demo Component
  attachmentTitleSingle = 'Default Attachment Component';

  //Specific to Multiple with API Demo Component
  attachmentTitleWithoutEdit =
    'Full File upload with multiple, maxfiles, max Size ,accepted Format without Edit flag';

  //Specific to Custom Demo Component
  appAcceptedType = [
    'pdf',
    'png',
    'docs',
    'xlsx',
    'csv',
    'm4v',
    'm4a',
    'm4p',
    'm4b',
    'm4r',
    'm4v',
    'mov',
  ]; //specify the type of docs
  appMaxSize = 5000000; //allowed maximum size //5MB
  appMaxFiles = 10; //allowed max files
  multipleAllowed = true; //allow to upload multiple files
  isEdit = true; //flag used to load existing attachment(s)
  appAttachID: unknown = '130603024'; // load existing attachment based on this ID
  appTempPath = ''; //e.g.= 3012922/1613985130412_8987756471539393322.tmp* *checked.png*  *0
  attachmentTitle = 'Custom Attachment Component'; //title
  attachmentID = 'Leave'; //any name for attchment component
  isAllowUpdate = true; //ignore it as currently not in use
  isAllowFileToAttach = true; //to restrict from uploading doc
  isAllowDelete = true; //to restrict from deleting any doc
  isMandatory = true; //specify mandatory or not
  isRefresh = false; //to refresh(reinitialize) the attachment component properties

  //Specific to Profile Component
  profileAttachTitle = 'Profile Attachment Component';
  isProfileComponent = true; //flag to indetify profile Attachment Component
  profileAcceptedType = ['png', 'jpeg', 'jpg'];
  profileMaxSize = 5000000;
  profileUniqueAttachID = 'User Profile';
  isAllowFileToAttachProfile = true;
  profileAttachID = '130573304'; //use either this or profileTempPath. In case we use both profileAttachID and profileTempPath then it will only consider profileAttachID.
  profileTempPath = ''; //use either this or profileAttachID.
  //Specific to ViewAttachDialog
  dialogAttachID = '130573304';
  showViewAttach = false;
  //Specific for smalle attachment icon
  attachSmall = true;
  appMaxFiles2 = 10;

  constructor(
    public http: HttpClient,
    private appInitService: AppInitService
  ) {}

  ngOnInit(): void {
    this.doc_url =
      this.appInitService?.appConfig?.dgDocUrl +
      '/components/DgFileUploadComponent.html';
  }
  onFinalPath(finalPath: Event): void {
    //Will provide the finalPath for first component
    console.log('finalPath>>>>', finalPath);
  }
  refreshComponent(): void {
    //call this method when it is required to refresh the Attachment component
    if (this.isRefresh) {
      this.isRefresh = false;
    } else if (!this.isRefresh) {
      this.isRefresh = true;
    }
  }
  //Specific to Profile Component
  onFinalPathForProfile(finalPath: Event): void {
    //Will provide the finalPath for first component
    console.log('finalPath>>>>', finalPath);
  }

  //Specific to ViewAttachDialog
  onDialogClose(): void {
    console.log('closed Dialog recieved>>>>');
    this.showViewAttach = false;
  }
}
